export default "__VITE_ASSET__e0379bc5__"